import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M21 9h-8a5 5 0 1 0 -5 5v7","key":"svg-0"}],["path",{"d":"M17 5l4 4l-4 4","key":"svg-1"}]]

/**
 * IconArrowRoundaboutRight
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYXJyb3ctcm91bmRhYm91dC1yaWdodCIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMjEgOWgtOGE1IDUgMCAxIDAgLTUgNXY3IiAvPgogIDxwYXRoIGQ9Ik0xNyA1bDQgNGwtNCA0IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/arrow-roundabout-right
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconArrowRoundaboutRight = createReactComponent('outline', 'arrow-roundabout-right', 'ArrowRoundaboutRight', __iconNode);

export default IconArrowRoundaboutRight;